import { getAuthAxiosBackend } from "@/helpers/axios"

class HousingTypeServices {
    get(id) {
        return getAuthAxiosBackend().get('HousingType/' + id.toString())
    }

    getAll(data = {}) {
        return getAuthAxiosBackend().get('HousingType/all', { params: data })
    }

    add(data) {
        return getAuthAxiosBackend().post('HousingType/add', data)
    }

    edit(id, data) {
        return getAuthAxiosBackend().put('HousingType/update/' + id, data)
    }

    restore(id, data) {
        return getAuthAxiosBackend().put('HousingType/restore/' + id, data)
    }

    delete(id) {
        return getAuthAxiosBackend().delete('HousingType/soft-delete/' + id.toString())
    }

    forceDelete(id) {
        return getAuthAxiosBackend().delete('HousingType/delete/' + id.toString())
    }
}

export default new HousingTypeServices()
